import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { setStatusVisualizado } from "../geracaoLeituraActions";

function StatusLeituraWifiComponent(props) {
    const estilo = props.style || {};
    const isMobile = window.innerWidth <= 768;

    const cor =
        props.item.corStatus === props.STATUS_COR_AMARELA
            ? "#FFCC22"
            : props.item.corStatus === props.STATUS_COR_VERMELHA
            ? "#FF1040"
            : props.item.corStatus === props.STATUS_COR_VERDE
            ? "#4AE30E"
            : "";

    const titulo =
        props.item.corStatus === props.STATUS_COR_AMARELA
            ? "Alguns inversores estão indisponíveis"
            : props.item.corStatus === props.STATUS_COR_VERMELHA
            ? "Indisponível"
            : props.item.corStatus === props.STATUS_COR_VERDE
            ? "Funcionando"
            : "";

    const isAlerta =
        !props.filtro.id_agrupador &&
        !props.item.status_visualizado &&
        [props.STATUS_COR_AMARELA, props.STATUS_COR_VERMELHA].includes(props.item.corStatus);

    return (
        <div
            style={{
                ...estilo,
                display: isMobile ? "flex" : "block",
                flexDirection: isMobile ? "row" : undefined,
                alignItems: isMobile ? "center" : undefined,
                gap: isMobile ? 10 : undefined,
            }}
        >
            {/* WIFI */}
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center"}}>
                <div
                    style={{
                        borderRadius: "15px",
                        position: "relative",
                        width: "20px",
                        height: "20px",
                        cursor: isAlerta ? "pointer" : "default",
                        color: cor,
                        boxShadow: props.noAlertBox ? "none" : undefined,
                    }}
                    className={
                        props.noAlertBox
                        ? null
                        : props.filtro.id_agrupador
                            ? null
                            : props.item.corStatus === props.STATUS_COR_AMARELA && !props.item.status_visualizado
                            ? "geracao-leitura-status-alerta-amarela"
                            : props.item.corStatus === props.STATUS_COR_VERMELHA && !props.item.status_visualizado
                            ? "geracao-leitura-status-alerta-vermelha"
                            : null
                    }
                    title={titulo}
                    onClick={() => {
                        if (
                            !props.item.status_visualizado &&
                            !props.filtro.id_agrupador &&
                            [props.STATUS_COR_AMARELA, props.STATUS_COR_VERMELHA].includes(props.item.corStatus)
                        ) {
                            const idOuListaIds = props.filtro.agrupar_por_uc
                                ? props.item.ids_agrupados
                                : props.item.id;

                            props.setStatusVisualizado(idOuListaIds);
                        }
                    }}
                >
                    <i className="fas fa-wifi"></i>

                    {/* Slash só no vermelho */}
                    {props.item.corStatus === props.STATUS_COR_VERMELHA && (
                        <i
                            className="fas fa-slash"
                            style={{
                                position: "absolute",
                                left: 0,
                                top: 0,
                                color: "#FF1040",
                            }}
                        />
                    )}
                </div>

                {/* Texto status */}
                <div
                    style={{
                        fontSize: "0.7rem",
                        color: cor,
                        marginTop: 2,
                    }}
                >
                    <b>
                        {props.item.corStatus === props.STATUS_COR_VERDE
                            ? "online"
                            : props.item.corStatus === props.STATUS_COR_AMARELA
                            ? "Parcial offline"
                            : "offline"}
                    </b>
                </div>
            </div>

            {/* DATA */}
            {!props.hideData && (
            <div style={{ fontSize: "14px" }}>
                {props.item.data_hora
                    ? new Date(props.item.data_hora)
                          .toLocaleString({
                              dateStyle: "short",
                              timeStyle: "medium",
                          })
                          .replace(",", "")
                    : "Nenhuma leitura"}
            </div>
            )}
        </div>
    );
}

const mapStateToProps = (state) => ({
    filtro: state.geracaoLeitura.filtro,
    STATUS_COR_AMARELA: state.geracaoLeitura.AMARELA,
    STATUS_COR_VERMELHA: state.geracaoLeitura.VERMELHA,
    STATUS_COR_VERDE: state.geracaoLeitura.VERDE,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({ setStatusVisualizado }, dispatch);

export const StatusLeituraWifi = connect(mapStateToProps, mapDispatchToProps)(StatusLeituraWifiComponent);